import React from "react";
import Admin from "us.collection.admin";
import { withRouter } from "us.common/wIthRouter";
import { useNavigate } from "react-router-dom";

const Cnt_NonProductionDaysHome: React.FC = (props) => {
  const navigate = useNavigate();

  const onMinimize = (state: any) => {
    navigate("/bureau", { state });
  };

  return (
    <Admin.Components.CreditorGroup.CreditorGroupHome
      onMinimize={onMinimize}
      {...props}
    />
  );
};

export default withRouter(Cnt_NonProductionDaysHome);
